import { render, staticRenderFns } from "./imRate.vue?vue&type=template&id=876e6668&scoped=true"
import script from "./imRate.vue?vue&type=script&lang=js"
export * from "./imRate.vue?vue&type=script&lang=js"
import style0 from "./imRate.vue?vue&type=style&index=0&id=876e6668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876e6668",
  null
  
)

export default component.exports